import clsx from "clsx";
import { DetailedHTMLProps, FC, HTMLAttributes } from "react";
import styles from "./Loader.module.scss";
import { LoaderProps } from "./__fixtures__/Loader.props";

type Props = LoaderProps &
  DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

export const Loader: FC<Props> = ({ size, color, ...props }) => {
  const inlineStyle = {
    width: `${size}px`,
    height: `${size}px`,
    borderTopColor: color,
    borderLeftColor: color,
    borderRightColor: color,
  };

  return (
    <div
      {...props}
      className={clsx(styles.loader, props.className)}
      style={inlineStyle}
    />
  );
};

export default Loader;
